export enum PositionDirection {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum PositionAlignment {
  START = 'start',
  MIDDLE = 'middle',
  END = 'end',
}
